import styled from 'styled-components'
import { Icon as IconBase } from '@alejandro.devop/bt-components'

export const ProfilePhoto = styled.div`
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
`

export const Icon = styled(IconBase)`
    background-color: #618833;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    & span {
    }
`

export const StatusWrapper = styled.span`
    display: inline-block;
    flex: 1;
`

export const ImageIcon = styled.img`
    width: 35px;
    height: 35px;
    margin-right: 10px;
    border-radius: 100%;
`

export const ItemWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
`

export const LoaderItemWrapper = styled.div``
